<template>
  <div class="shop-plans">
    <div class="top">
      <img :src="tukWord" @click="$router.go(-1)" />
      <span>SHOP</span>
      <div
        class="is-pulled-right is-uppercase link language"
        @click="openLanguageSelector"
      >
        {{ $store.state.language }}
      </div>
    </div>
    <div class="wrapper">
      <div ref="scrollable" class="scrollable no-scrollbar">
        <div v-if="showDetails" class="details-wrapper">
          <p class="plan-header" @click="showDetails = false">
            <span class="link">Show Plans</span>
            <span class="plan-title is-uppercase has-text-info">{{
              plan
            }}</span>
            <br />
            Plan Details
          </p>
          <table class="table is-fullwidth is-bordered">
            <tbody v-for="section in details" :key="section.header">
              <tr>
                <th colspan="2">{{ section.header }}</th>
              </tr>
              <tr v-for="(item, i) in section.items" :key="section.header + i">
                <td>
                  {{ item.item }}
                  <span class="price tag">
                    <span v-if="item.price" class="has-text-link">{{
                      item.price
                    }}</span>
                    <span v-else>Free</span>
                  </span>
                  <p class="description">{{ item.description }}</p>
                </td>
                <td class="has-text-centered">
                  <span v-if="planHasItem(item)"
                    ><i class="fa fa-check has-text-success"
                  /></span>
                  <span v-else>-</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <span
              v-if="isAcknowledge"
              class="button is-fullwidth is-medium is-info is-outlined"
              @click="acknowledge"
            >
              Acknowledge
            </span>
            <span
              v-else
              class="button is-fullwidth is-medium is-info is-outlined"
              @click="start"
              >Get Started!</span
            >
          </div>
        </div>

        <div v-else>
          <div class="one-liner has-text-weight-bold">
            <p>Set-up a Shop for FREE</p>
            <p class="has-text-warning">
              <i>Immediate Payouts!</i>
            </p>
          </div>
          <div class="subtitle">Pick a plan later, Change it anytime</div>
          <div class="btn-wrapper">
            <a
              class="button is-fullwidth is-large is-rounded is-info"
              @click="gotoShopCreate"
            >
              Start Selling In Seconds
            </a>
          </div>

          <div class="plan notification" @click="showPlan('free')">
            <p class="name">FREE</p>
            <p class="callout"><i>Get Started Here!</i></p>
            <p>Create your online store</p>
            <p>Sell to your customers</p>
            <p class="button is-white has-text-info">
              <i class="fa fa-ellipsis-h" />&nbsp;Show Plan Details
            </p>
          </div>

          <div class="plan notification" @click="showPlan('professional')">
            <p class="name">PROFESSIONAL</p>
            <p class="callout"><i>Need more professional features?</i></p>
            <p>Upgrade your online store</p>
            <p>Unlock more fulfilment options</p>
            <p class="button is-white has-text-info">
              <i class="fa fa-ellipsis-h" />&nbsp;Show Plan Details
            </p>
          </div>

          <div class="plan notification" @click="showPlan('advanced')">
            <p class="name">ADVANCED</p>
            <p class="callout"><i>Need special support?</i></p>
            <p>High order volume</p>
            <p>Advanced data reporting</p>
            <p class="button is-white has-text-info">
              <i class="fa fa-ellipsis-h" />&nbsp;Show Plan Details
            </p>
          </div>

          <div class="faq-wrapper">
            <div class="faq">Frequently Asked Questions</div>
            <div
              v-for="(q, i) in faqs"
              :key="'faq' + i"
              class="faq-item"
              @click="showAnswer(i)"
            >
              <p class="question">
                {{ q.question }}
                <span class="is-pulled-right">
                  <i
                    v-if="answer === i"
                    class="fa fa-chevron-up has-text-black"
                  />
                  <i v-else class="fa fa-chevron-down has-text-grey" />
                </span>
              </p>
              <p v-if="answer === i" class="answer">{{ q.answer }}</p>
            </div>
            <!-- <div style="padding: 20px" @click="contactMerchantSupport">
              <p class="question">
                More questions?&nbsp;
                <span class="link has-text-info">Contact Us</span>
              </p>
            </div> -->
          </div>
        </div>
        <div style="padding: 20px" @click="contactMerchantSupport">
          <p class="question">
            More questions?&nbsp;
            <span class="link has-text-info">Contact Us</span>
          </p>
        </div>
      </div>
    </div>

    <ShopPlansAcknowledge
      v-if="showAcknowledge"
      @close="showAcknowledge = false"
    />
  </div>
</template>

<script>
import ShopPlansAcknowledge from "@/components/ShopPlansAcknowledge.vue";

export default {
  name: "ShopPlans",
  components: { ShopPlansAcknowledge },
  data() {
    return {
      showAcknowledge: false,
      isAcknowledge: true,
      answer: null,
      plan: null,
      showDetails: false,
      tukWord: require("../../public/img/icons/transparent-dark-180x180.png"),
      details: [
        {
          header: "Features",
          items: [
            {
              item: "Online Store",
              description: `Your online store is available to customers on both mobile and web. We even provide you with QR codes and custom links to show to your customers on social media and in-store.`,
            },
            {
              item: "Digital Menu",
              description: `You have full control of your digital menu - from adding and removing items to changing the prices anytime you want.`,
            },
            {
              item: "Advanced Menu Options",
              description: `Categories? Specials? Flash Deals? Tags? Sub-menus? Get all sorts of advanced pricing functionality for free!`,
            },
            {
              item: "Advanced Pricing Options",
              description: `Set custom discounts on items or by fulfilment type. For example, offer 10% discount on take-away orders. Various VAT settings to fit your business. Get advanced pricing options for free!`,
            },
            {
              item: "Staff Accounts",
              description: `You can have unlimited staff accounts and install the merchant app on as many devices as possible. You can use the merchant app on mobile phones, tablets and computers!`,
            },
          ],
        },
        {
          header: "Fulfilment",
          items: [
            {
              item: "Dine-in / In-store",
              description: `QR code menus for your customers to order while in-store. Digital menus for your customers to order dine-in ahead of time.`,
            },
            {
              item: "Take-away / Self-pickup",
              description: `Your customers can order ahead and pickup themselves.`,
            },
            {
              item: "Delivery",
              description: `Let us handle the delivery or you can choose to set-up your own fleet. We apply a 20% fee on delivery order values - a portion of which goes to offset the delivery fee to the customer and the rest to cover the cost of the service.`,
              price: "20%",
              plans: ["paid"],
            },
            {
              item: "Self-Delivery",
              description: `Have your own fleet? You can use your own drivers to increase your shop's revenue. We provide the necessary driver app for free!`,
              plans: ["paid"],
            },
          ],
        },
        {
          header: "Payments",
          items: [
            {
              item: "Immediate Payouts",
              description: `Get paid immediately on all orders.`,
            },
            {
              item: "Accept Cash and Digital Cash",
              description: `We support cash payments as well as digital cash payments such as Bank Transfers and PromptPay.`,
            },
          ],
        },
        {
          header: "Advanced",
          items: [
            {
              item: "Community Support",
              description: `The TUK community of merchants, service providers and developers are always happy to help answer your questions and help your business grow.`,
            },
            {
              item: "Premium Support",
              description: `You can reach out to the TUK Support team for help anytime.`,
              plans: ["paid"],
            },
            {
              item: "Custom Pricing",
              description: `Talk to us to see if your shop qualifies for special pricing.`,
              price: "??%",
              plans: ["advanced"],
            },
            {
              item: "Advanced Data Reporting",
              description: `Get advanced data reporting to fit your business needs.`,
              plans: ["advanced"],
            },
          ],
        },
      ],
      faqs: [
        {
          question: "Is it really FREE?",
          answer: `You can set up your shop and sell to your customers for free. If you require premium features (see above) you can upgrade to a premium plan anytime.`,
        },
        {
          question: "How do I get started?",
          answer: `Just start setting up your shop and selling to your customers for FREE. Tell us anytime you want to add premium features to your shop.`,
        },
        {
          question: "How do I change from FREE to PROFESSIONAL?",
          answer: `To upgrade your online shop from FREE to PROFESSIONAL just send us a message and our Support Team will help you ASAP.`,
        },
        {
          question: "How much does TUK charge?",
          answer: `TUK is FREE to use if you're setting up an online store to sell to your customers. If you need to upgrade your online store and unlock more fulfilment options like integrated delivery we charge 20% of the order value on those transactions.`,
        },
        {
          question: "How do I get paid for orders?",
          answer: `
          All plans feature IMMEDIATE PAYOUTS for all orders.
          If it's a dine-in or take-away order the customer will pay you directly as per usual.
          If it's a delivery order the driver will pay you when they come to pick up the order.
          `,
        },
      ],
    };
  },
  mounted() {
    this.checkLangQuery("en");
    this.checkFCMQuery();
  },
  methods: {
    showAnswer(i) {
      if (this.answer === i) this.answer = null;
      else this.answer = i;
    },
    start() {
      var msg = `First tell us your mobile number`;
      if (!this.smsLoginOkay(msg)) return;
      this.goto("shop_create");
    },
    acknowledge() {
      this.showAcknowledge = true;
    },
    planHasItem(item) {
      if (!item.plans) return true;
      if (this.plan !== "free" && item.plans.includes("paid")) return true;
      return item.plans.includes(this.plan);
    },
    showPlan(plan) {
      this.plan = plan;
      this.showDetails = true;
      this.$refs.scrollable.scrollTo(0, 0);
    },
    gotoShopCreate() {
      if (this.isAcknowledge) this.acknowledge();
      else this.goto("/shop_create"); // this.start();
    },
    seeShops() {
      this.goto("/eat?r=cm");
    },
    comingSoon() {
      // var msg = "Hey y'all 🙌🏼<br>Any ideas? 💡";
      // this.warningToast(msg);
      var msg = `Opening live chat support&nbsp;<i class="fa fa-spinner fa-spin" />`;
      this.warningToast(msg);
      setTimeout(() => this.contactFBMessengerSupport(), 800);
    },
  },
};
</script>

<style scoped>
.shop-plans {
  background-color: whitesmoke;
  width: 100vw;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
}
.wrapper {
  margin: auto;
  max-width: 700px;
  max-height: 100vh;
  overflow: hidden;
  margin-top: 80px;
}
.scrollable {
  position: relative;
  /* height: 100vh; */
  overflow: scroll;
  max-height: 100vh;
  padding-bottom: 200px;
  /* margin-bottom: 1000px; */
  z-index: 1;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tuk-icon {
  background-image: url("../../public/img/icons/round-512x512.png");
  position: absolute;
  height: 150px;
  width: 150px;
  /* height: min(50vw, 50vh);
  width: min(50vw, 50vh); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.top {
  width: 100vw;
  /* max-width: 700px; */
  text-align: left;
  box-shadow: 0 0 5px grey;
  background-color: white;
  z-index: 2;
  /* position: relative; */
  position: absolute;
}
.top img {
  display: inline-block;
  height: 100px;
  /* margin-right: 10px; */
  margin-top: -10px;
  margin-bottom: -16px;
  margin-left: 4px;
}
.top span {
  font-size: 28pt;
  font-weight: 550;
  color: #fac002;
  margin-top: 18px;
  margin-left: -10px;
  position: absolute;
}
.one-liner {
  padding: 20px;
  /* padding-top: 30px; */
  font-size: 36px;
  font-weight: 900 !important;
}
.one-liner i {
  text-shadow: 1px 1px 2px black;
  /* text-shadow: 0 0 1px black; */
  /* text-transform: uppercase; */
}
.subtitle {
  /* margin-top: 20px; */
  padding: 12px;
  margin-bottom: 20px;
}
.btn-wrapper {
  padding: 16px;
}
.btn-wrapper .button {
  /* margin-top: 10px; */
  /* background-color: #fac002; */
  color: black;
  font-weight: 600;
  box-shadow: 3px 3px 9px grey;
}
.free {
  font-size: 40pt;
  font-weight: 900;
}
.bottom {
  padding: 12px;
  position: absolute;
  bottom: 0;
  width: 100vw;
  max-width: 700px;
  font-size: 1.4em;
  background-color: rgba(221, 221, 221, 0.5);
  backdrop-filter: blur(3px);
}
.language {
  margin: 12px;
  font-weight: 500;
  color: grey;
}
/* ///////////////// */
.plan {
  margin: 24px 16px;
  /* box-shadow: 1px 1px 5px var(--info); */
  box-shadow: 0 0 6px #888;
  background-color: white;
}
.plan:hover {
  /* background-color: rgba(99, 243, 253, 0.555); */
  border: 1px solid var(--info);
  box-shadow: 0 0 6px #bbb;
}
.name {
  font-weight: 500;
  font-size: 2em;
}
.plan i {
  color: #999;
}
.callout {
  padding: 10px 0;
}
.plan .button {
  margin: 6px 0;
}
.details-wrapper {
  /* position: absolute;
  top: 0; */
  margin: 16px;
  margin-top: 20px;
  padding: 16px;
  height: 100%;
  width: calc(100% - 32px);
  background-color: white;
  text-align: left;
  border-radius: 4px;
  box-shadow: 0 0 6px #888;
}
.plan-header {
  font-size: 1.1em;
  font-weight: 500;
  margin-bottom: 10px;
}
.plan-title {
  font-size: 1.4em;
  margin-right: 9px;
}
.plan-header .link {
  float: right;
  color: grey;
  margin-top: 4px;
  font-size: 0.8em;
}
.description {
  color: grey;
  font-size: 0.9em;
}
.price {
  float: right;
  opacity: 0.7;
  font-weight: 500;
  padding: 6px;
}
.faq-wrapper {
  padding: 0 20px;
  margin-top: 40px;
}
.faq {
  font-size: 1.2em;
  font-weight: 500;
  margin-bottom: 10px;
}
.faq-item {
  text-align: left;
  border-bottom: 3px solid #ddd;
}
.question {
  margin: 16px 4px;
  color: #444;
  font-weight: 500;
}
.answer {
  margin: 16px 4px;
  margin-top: -8px;
  color: #777;
  /* font-weight: 400; */
}
</style>